import slugify from 'modules/fou-slugify'
import { get } from 'lodash'

import {getCurrentInstance} from 'vue'

const VueId = {
  install(app, options = {}) {
    /*
     * Optional exceptions:
     * except {Array}
     * excludeRoot {String}
     */
    let excludeNames = typeof options.except === 'object'
      ? options.except
      : []
    let excludeRoot = typeof options.excludeRoot === 'string'
      ? options.excludeRoot
      : null

    app.mixin({
      props: {
        id: {
          type: String,
          default: function () {
            /*
             * Warn if no id was set.
             * Respect exceptations though.
             */
            let name = getCurrentInstance && get(getCurrentInstance(), 'type.name') /* ((this || {}).$options || {})._componentTag*/

            let parentName = getCurrentInstance && get(getCurrentInstance(), 'parent.type.name', '') /*(((this || {}).$parent || {}).$options || {})._componentTag || ''*/

            if (
              this &&
              typeof name === 'string' &&
              parentName.toLowerCase() !== excludeRoot &&
              !excludeNames.some(n => n === name.toLowerCase())
            ) {
              console.warn('[vue warn] (vue-id): No id set for component “' + name + '”. You should either add :id="$vId(this)" to its attributes or add its componentTag to the exception list in vue-id options.')
            }
          }
        }
      },
      created () {
        /**
         * this takes care, that no one overrides the props id by setting an id property in data()
         */
        if (typeof this.$data.id !== 'undefined') {
          console.warn('[vue warn] (vue-id): Do not set properties named “id” in data.\nFound in component: “' + this.$options._componentTag + '”')
        }
      }
    })

    app.config.globalProperties.$vId = (instance, name) => {
      /**
       * Usage:
       * Pass this function to :id of the component tag. Like: $vId(this)
       * You should at least pass the instance, normally ‘this’.
       * This allows to the function to seeks for the $options.name of the instance.
       * Optionally you can pass a name.
       */
      instance = instance || {}
      /**
       * Set array.
       */
      let slug = []
      /**
       * If only a string is passed.
       */
      if (typeof instance === 'string') {
        slug.push(instance)
      }
      /**
       * If instance is object.
       */
      if (typeof instance === 'object' && !Array.isArray(instance)) {
        if (instance.id) {
          slug.push(instance.id)
        }
        if ((instance.$options || {}).name) {
          slug.push(instance.$options.name)
        }
        if (typeof name === 'string' && name !== '') {
          slug.push(name)
        }
      }
      slug = slug.map(s => {
        if (typeof s === 'string') {
          return slugify(s)
        }
      })
      return (slug.join('-')).toLowerCase()
    }
  }
}

export default VueId
